import { render, staticRenderFns } from "./userAgr.vue?vue&type=template&id=80aa7110&scoped=true"
import script from "./userAgr.vue?vue&type=script&lang=js"
export * from "./userAgr.vue?vue&type=script&lang=js"
import style0 from "./userAgr.vue?vue&type=style&index=0&id=80aa7110&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80aa7110",
  null
  
)

export default component.exports